<template>
  <div class="page-container">
    <!-- <el-breadcrumb separator="/">
      <el-breadcrumb-item>理财功能</el-breadcrumb-item>
    </el-breadcrumb> -->
    <router-view></router-view>
  </div>
</template>

<script>
import './store'

import { mapActions, mapState } from 'vuex'

export default {
  name: 'Financial',
  data() {
    return {
      times: [],
      params: {
        coinType: '',
        type: '',
        queryType: '0',
        queryValue: '',
        id: '',
        address: '',
        hashCode: '',
      },
    }
  },
  computed: {
    ...mapState('bill', ['coinList', 'pagination']),
    startTime() {
      return this.times ? this.times[0] : ''
    },
    endTime() {
      return this.times ? this.times[1] : ''
    },
  },
  methods: {
    ...mapActions('bill', ['getUserBillList', 'listAllCoin']),
    refreshList(data = {}) {
      this.getBill({
        ...this.params,
        ...this.pagination,
        ...data,
      })
    },
    getBill(data) {
      this.getUserBillList({
        startTime: this.startTime,
        endTime: this.endTime,
        ...this.params,
        ...this.pagination,
        ...data,
      })
    },
  },
  created() {
    this.listAllCoin()
    this.getBill()
  },
  components: {},
}
</script>

<style lang="less" scoped></style>
